<template>
    <div style="width: 100%;padding:0;margin:0">
      <div v-for="air_data in schedule_data"
           v-bind:key="air_data.fulldate"
           v-bind:suffix="''"
           style="border-bottom: 1px solid #00000033;"
           :class="`${selected_air_data === air_data && Object.keys(selected_air_data).length > 0 ? 'schedule-open':'schedule-row'}  uk-visible@s`">

        <div class="uk-grid uk-grid-small uk-visible@s" style="max-width: 1140px; margin: auto; padding: 5px 0;">
          <!-- :style="(selected_air_data.fulldate != undefined && selected_air_data.fulldate == air_data.fulldate)
                    ? 'background-color: #f8f5ec;max-width: 1200px; margin: auto;'
                    :'max-width: 1200px; margin: auto;'"-->

          <div @click="set_air_data(air_data)" class="uk-width-1-6@m" style="padding: 5px;padding-left:0">
            <div class="pbs-schedule-grid-time2" style="font-size: 18px;padding-left:10px;text-align: left">
              {{air_data.show_time}} {{air_data.short_week_date}} <!--{{air_data.short_date}} on {{channel}}-->
            </div>
            <div class="pbs-schedule-grid-time2" style="padding-left:10px;text-align: left;font-size: 18px;">
              {{air_data.short_date}}
            </div>

          </div>

          <div @click="set_air_data(air_data)" :class="`uk-width-2-3@s ${(route_current_episode_id === air_data.episode_id) ? 'current-allairdtes-episode':''}`" style="padding: 5px 10px;">
            <div class="pbs-schedule-grid-title2" style="margin-bottom: 10px;">{{air_data.series_title}}</div>
            <div class="pbs-schedule-grid-subtitle2" v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title">{{air_data.episode_title}}</div>
            <div class="pbs-schedule-grid-subtitle2" style="opacity: 0" v-else>_</div>
          </div>

          <div class="uk-width-1-6@s uk-hidden@xs uk-visible@s" style="padding: 5px">
            <div style="float: right; width: 100%;">

              <div v-if="selected_air_data === air_data" @click="set_air_data({})" class="minus-button"></div>
              <a v-else @click="set_air_data(air_data)" class="x-button" :id="`${(air_data.now_playing)?'schedule-now-playing':''}`"></a>

              <!-- Tablet - PASSPORT or PUBLIC -->
              <a v-if="air_data.program_details.display_option == 9
                                && is_passport_full_length(air_data)" target="_blank"
                 :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.passport.asset_slug}/`"
                 class="pbs-play-button uk-visible@s uk-hidden@m"></a>
              <a v-else-if="air_data.program_details.display_option == 9
                                && is_public_full_length(air_data)" target="_blank"
                 :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.public.asset_slug}/`"
                 class="pbs-play-button uk-visible@s uk-hidden@m"></a>


              <!-- Regular width - PASSPORT or PUBLIC -->
              <a class="button-schedule button-watch-now uk-hidden@xs uk-visible@m" v-if="air_data.program_details.display_option == 9
                                && is_passport_full_length(air_data)" target="_blank"
                 :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.passport.asset_slug}/`">watch now</a>
              <a class="button-schedule button-watch-now uk-hidden@xs uk-visible@m" v-else-if="air_data.program_details.display_option == 9
                                && is_public_full_length(air_data)" target="_blank"
                 :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.public.asset_slug}/`">
                <span v-if="air_data.program_details.media_manager_data.public.type === 'full_length'">watch now</span>
                <span v-else>watch preview</span>
              </a>
            </div>
          </div>
        </div>
        <!--CONTENT-->
        <ProgramDetails v-if="(selected_air_data === air_data && Object.keys(selected_air_data).length > 0)"
                        v-bind:air_data="air_data" v-bind:open_passport="(air_data.program_details.display_option == 9
                                && air_data.program_details.media_manager_data.passport != null
                                && air_data.program_details.media_manager_data.passport != undefined)"/>
    </div>
    <div v-for="air_data in schedule_data"
         v-bind:key="`mobile-${air_data.fulldate}`"
         :id="`${(air_data.now_playing)?'schedule-now-playing-mobile':''}`"
         :class="`${selected_air_data === air_data && Object.keys(selected_air_data).length > 0 ? 'schedule-open':''}   uk-grid uk-grid-small uk-visible@xs uk-hidden@s schedule-bg-hover gridcenter1200 ${(air_data.now_playing)?'schedule-now-playing-mobile':''}`"
         style="padding: 5px 0;border-top: 1px solid rgba(0,0,0,.5);">

      <div @click="set_air_data(air_data)" class="uk-width-1-3" style="padding: 5px;">
        <div class="pbs-schedule-grid-time2" style="font-size: 16px;padding-left:10px;text-align: left">
          {{air_data.show_time}} {{air_data.short_week_date}} <!--{{air_data.short_date}} on {{channel}}-->
        </div>
        <div class="pbs-schedule-grid-time2" style="padding-left:10px;text-align: left;font-size: 16px;">
          {{air_data.short_date}}
        </div>
      </div>
      <div class="uk-width-2-3" style="padding: 5px;">
        <div v-if="selected_air_data === air_data" @click="set_air_data({})" class="minus-button"></div>
        <a v-else @click="set_air_data(air_data)" class="x-button"></a>

        <div class="uk-width-2-3" style="padding: 5px;" hidden>
          <div class="x-button"></div>
          <div class="button-schedule button-watch-now">watch now</div>
        </div>
        <!-- Mobile - PASSPORT or PUBLIC -->
        <a class="button-schedule button-watch-now" v-if="air_data.program_details.display_option == 9
                              && is_passport_full_length(air_data)" target="_blank"
           :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.passport.asset_slug}/`">watch now</a>

        <a class="button-schedule button-watch-now" v-else-if="air_data.program_details.display_option == 9
                              && is_public_full_length(air_data)" target="_blank"
           :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.public.asset_slug}/`">
          <span v-if="air_data.program_details.media_manager_data.public.type === 'full_length'">watch now</span>
          <span v-else>watch preview</span>
        </a>

      </div>
      <div @click="set_air_data(air_data)" class="uk-width-1-1" style="padding:10px;">
        <div class="pbs-schedule-grid-title2" style="margin-bottom: 10px;">{{air_data.series_title}}</div>
        <div class="pbs-schedule-grid-subtitle2" v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title">{{air_data.episode_title}}</div>
        <div class="pbs-schedule-grid-subtitle2" v-else>&nbsp;</div>
      </div>
      <!--CONTENT-->
      <ProgramDetails v-if="(selected_air_data === air_data && Object.keys(selected_air_data).length > 0)"
                      v-bind:air_data="air_data"
                      v-bind:suffix="'mobile'"
                      v-bind:open_passport="(air_data.program_details.display_option == 9
                              && air_data.program_details.media_manager_data.passport != null
                              && air_data.program_details.media_manager_data.passport != undefined)"/>
    </div>
  </div>
</template>

<script>

import ProgramDetails from "./ProgramDetails";
import uk from "uikit";

export default {
    name: "SearchAccordionLine",
    components:{
      ProgramDetails
    },
    props: ['air_data','channel','schedule_data'],
    data(){
      return {
        selected_air_data: {}
      }
    },
    mounted() {
      setTimeout(() => {
        //$('.current-allairdtes-episode').click()
        const elements = document.querySelectorAll('.current-allairdtes-episode');
        Array.from(elements).forEach((element, index) => {
          if(index === 0){
            uk.scroll('#bottom_app_div', {offset: 0}).scrollTo('#app')
            element.click()
          }
        });
      }, 1500)
    },
    computed:{
      route_current_episode_id(){
        return this.$router.currentRoute.params._episode_id
      }
    },
    methods:{
        is_passport_full_length(air_data){
          return air_data.program_details.media_manager_data.passport != undefined && air_data.program_details.media_manager_data.passport != null && (air_data.program_details.media_manager_data.public === undefined || air_data.program_details.media_manager_data.public === null || air_data.program_details.media_manager_data.public.type !== 'full_length')
        },
        is_public_full_length(air_data){
          return air_data.program_details.media_manager_data.public != undefined && air_data.program_details.media_manager_data.public != null
        },
        format_date(fulldate){
            const event = new Date(Date.parse(fulldate))
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
            //console.log(event.toLocaleDateString('en-US', options))
            return event.toLocaleDateString('en-US', options)
        },
        set_air_data(data){
          this.selected_air_data = data
          this.first_click = false
        }
    }
}
</script>

<style scoped>
    .uk-accordion-title:hover{
        /*background: #fff9c7;*/
        background: white;
    }
    .uk-accordion-title{
      /*max-width: 1245px;*/
      margin-left: auto;
      margin-right: auto;
    }
    .uk-accordion > :nth-child(n+2) {
        margin-top: 0px;
    }
    .schedule-open{
      background: white;
    }
    .schedule-bg-hover:hover{
      background-color: white;
    }
    .schedule-open:hover{
      background: white;
    }
    .schedule-row:hover{
      background: white;
    }
</style>